module.exports = __webpack_public_path__ + "static/hkgrotesk-italic-247a0a3ae80ccf592b6bfb07264b54ad.eot";